module.exports = __webpack_public_path__ + "img/3000.e0018df3.jpg";